var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirDrop = function SvgAirDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9EDFF",
    d: "M25.371 47.708c10.936 0 19.8-8.865 19.8-19.8s-8.864-19.8-19.8-19.8-19.8 8.865-19.8 19.8 8.865 19.8 19.8 19.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.446 25.227-2.404 12.086a.495.495 0 0 0 .39.582l14.883 2.96a.495.495 0 0 0 .582-.39l2.404-12.085a.495.495 0 0 0-.39-.582l-14.883-2.96a.495.495 0 0 0-.582.389"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M28.158 34.894s-1.043 2.701-3.842 2.145c-2.798-.556-2.686-3.443-2.686-3.443z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#020064",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M21.066 31.047a.713.713 0 1 0 0-1.427.713.713 0 0 0 0 1.427Zm8.86 1.761a.713.713 0 1 0 0-1.427.713.713 0 0 0 0 1.427Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "m18.446 25.227-2.404 12.086a.495.495 0 0 0 .39.582l14.883 2.96a.495.495 0 0 0 .582-.39l2.404-12.085a.495.495 0 0 0-.39-.582l-14.883-2.96a.495.495 0 0 0-.582.389"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    d: "M16.459 13.177c.255-1.287 2.238-1.98 4.427-1.543s3.756 1.832 3.5 3.118c.256-1.287 2.342-1.958 4.66-1.496s3.99 1.878 3.734 3.168c.255-1.287 2.237-1.98 4.427-1.544 2.19.437 3.756 1.832 3.5 3.119l.185-.933a12.362 12.362 0 0 0-24.248-4.822z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M16.459 13.177c.255-1.287 2.238-1.98 4.427-1.543s3.756 1.832 3.5 3.118c.256-1.287 2.342-1.958 4.66-1.496s3.99 1.878 3.734 3.168c.255-1.287 2.237-1.98 4.427-1.544 2.19.437 3.756 1.832 3.5 3.119l.185-.933a12.362 12.362 0 0 0-24.248-4.822zm0 .001 8.125 12.765m-.198-11.189 1.597 11.467m6.797-9.798-5.864 9.983M40.706 18l-12.392 8.684"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M25.265 10.567q-.176.658-.323 1.39m5.119-8.678s-2.536 1.144-4.204 5.467m7.711 3.473q-.087.674-.232 1.406m-1.41-9.975s1.905 2.027 1.793 6.66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.873 21.545a1.605 1.605 0 0 0-2.538-1.656 3.228 3.228 0 0 0-5.69 2.092V22a1.61 1.61 0 0 0-1.38 2.702 1.61 1.61 0 0 0 1.177.507h7.267a2.015 2.015 0 0 0 1.163-3.663l.001-.002Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M14.873 21.545a1.605 1.605 0 0 0-2.538-1.656 3.228 3.228 0 0 0-5.69 2.092V22a1.61 1.61 0 0 0-1.38 2.702 1.61 1.61 0 0 0 1.177.507h7.267a2.015 2.015 0 0 0 1.163-3.663l.001-.002Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.896 35.292a1 1 0 0 0-.123-.777 1.02 1.02 0 0 0-1.488-.275 2.05 2.05 0 0 0-3.613 1.327v.013a1 1 0 0 0-.129-.013 1.025 1.025 0 1 0 0 2.05h4.614a1.28 1.28 0 0 0 .739-2.325"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M42.896 35.292a1 1 0 0 0-.123-.777 1.02 1.02 0 0 0-1.488-.275 2.05 2.05 0 0 0-3.613 1.327v.013a1 1 0 0 0-.129-.013 1.025 1.025 0 1 0 0 2.05h4.614a1.28 1.28 0 0 0 .739-2.325"
  })));
};
export default SvgAirDrop;